export default (app) => {
  const $inject = ['AnalyticsProvider', 'APP_CONFIG'];

  const GAConfig = function (AnalyticsProvider, APP_CONFIG) {
    if (!APP_CONFIG.analytics.enabled) {
      return false;
    }

    AnalyticsProvider.setAccount(APP_CONFIG.analytics.trackingCode);
    //AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    AnalyticsProvider.trackPages(false);
    AnalyticsProvider.useECommerce(true, false);

    if (location.hostname === 'localhost') {
      AnalyticsProvider.setDomainName('none');
    }
  };

  GAConfig.$inject = $inject;

  return GAConfig;
};



// WEBPACK FOOTER //
// ./src/config/gaConfig.js